import { Component, OnInit } from '@angular/core';
import {CommonService} from "../../../shared/services/common.service";
import {Utils} from "../../../../common/services/Utils";
import {EsuvoOptionService} from "../../../shared/services/esuvo-option.service";
import {Principal} from "../../../../common/services/principal";
import {TranslateService} from '@ngx-translate/core';
import {DomSanitizer} from '@angular/platform-browser';
import {EmbedVideoService} from 'ngx-embed-video';
import {ActivatedRoute, Router} from '@angular/router';
import {LangChange} from "../../../../lang-change";
import {Language} from "../../../../common/models/language";
import {NewsSharedService} from "../../services/news-shared.service";
import {News} from "../../../moderator/components/add-edit-news/model/news";
import {NewsStatusesENUM} from "../../../../common/enums/news-statuses.enum";
import {NewsComment} from "./model/news-comment";
import {UserInfo} from "../../../user/components/user-information/users-info";
import {NewComment} from "./model/new-comment";

@Component({
  selector: 'app-news-layout',
  templateUrl: './news-layout.component.html',
  styleUrls: ['./news-layout.component.scss']
})
export class NewsLayoutComponent extends LangChange implements OnInit {
  isModerator: boolean = false;
  isNewsOwner: boolean = false;
  userDto: UserInfo = null;
  newsId: number;
  tagId: number;
  news: News;
  newsTitle: String;
  newsTags: any[];
  pageTags: any[];
  newsModerators: any[];
  newsContent: any;
  newsVideoLink: null;
  newsVideoIframeHtml: null;
  newsImage: any;
  newsImageLink: string;
  newsDate: Date | number;
  authorInfo = {
    fullName: '',
    position: '',
    address: '',
    contacts: '',
    email: '',
    avatar: '',
    id: null
  };
  comments: NewsComment[] = [];
  sendComment: NewComment = new NewComment();
  authorAvatarHolder = 'assets/images/avatar.png';
  creatorId: number;

  constructor(private _commonService: CommonService,
              public _translateService: TranslateService,
              private _utils: Utils,
              private sanitizer: DomSanitizer,
              private embedService: EmbedVideoService,
              private route: ActivatedRoute,
              private router: Router,
              private _footerService: EsuvoOptionService,
              private _principal: Principal,
              private newsSharedService: NewsSharedService) {
    super(_translateService);
  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      this.newsId = +params['newsId'];
      if (this.newsId) {
        if (this._principal.isLoggedIn()) {
          this.userDto = this._principal.getUser();
        }
        this.loadNewsContent();
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  loadNewsContent() {
    this._utils.blockStart(null);
    this.newsSharedService.getNewsContent(this.newsId).subscribe(data => {
      if (data) {
        this.newsModerators = data['moderators'];
        if (this._principal.isLoggedIn() && this.newsModerators) {
          this.isModerator = this.newsModerators.indexOf(this._principal.getUserId()) > -1;
        }
        if (data['status'] === NewsStatusesENUM.PUBLISHED || (data['status'] && this.isModerator)) {
          this.news = data;
          this.getNewsData(data);
          if (this._principal.isLoggedIn()) {
            this.isNewsOwner = (this._principal.getUserId() === this.news.creatorId);
          }
        } else {
          if (this._principal.isLoggedIn() && this.newsModerators) {
            if (this.newsModerators.indexOf(this._principal.getUserId()) > -1) {
              this.isModerator = true;
            }
          } else {
            this.router.navigate(['/']);
          }
        }
      }
    }, error => {
      this._utils.notifyError('loadNewsContent error!', null);
      console.log('error', error);
    });
    this._utils.blockStop();
  }

  getNewsData(data) {
    switch (this._translateService.currentLang) {
      case 'kz':
        return this.getNewsDataByLang('Kz', data);
      case 'ru':
        return this.getNewsDataByLang('Ru', data);
      case 'en':
        return this.getNewsDataByLang('En', data);
    }
  }

  getNewsDataByLang(lang: string, data: any) {
    this._utils.blockStart(null);
    this.newsTitle = data['name' + lang];
    this.newsTags = data['newsTags' + lang];
    this.newsContent = data['newsContent' + lang];
    if (data['newsImageId' + lang]) {
      this.newsVideoLink = null;
      this.newsVideoIframeHtml = null;
      this.newsImage = data['newsImageId' + lang];
      this.newsSharedService.getNewsImage(data['id'], this.newsImage).subscribe(data => {
        this.newsImageLink = window.URL.createObjectURL(new Blob([data], {type: data.type}));
      }, error => {
        console.log('getFile error', error);
      });
    } else if (data['newsVideoLink' + lang]) {
      this.newsImage = null;
      this.newsVideoLink = data['newsVideoLink' + lang];
      this.newsVideoIframeHtml = this.embedService.embed(this.newsVideoLink);
    } else if (!data['newsImageId' + lang] && !data['newsVideoLink' + lang]) {
      this.newsImage = null;
      this.newsVideoLink = null;
    }
    this.authorInfo.fullName = data['authorName'];
    switch (lang) {
      case 'Kz': this.authorInfo.position = data['authorPositionKz'];
      case 'Ru': this.authorInfo.position = data['authorPositionRu'];
      case 'En': this.authorInfo.position = data['authorPositionEn'];
    }
    this.authorInfo.address = data['authorAddress'];
    this.authorInfo.contacts = data['authorContacts'];
    this.authorInfo.email = data['authorEmail'];
    this.authorInfo.id = data['authorId'];
    if (data['authorAvatar']) {
      if (data['authorAvatar'].length === 24) {
        this.newsSharedService.getNewsAuthorAvatar(this.newsId, data['authorAvatar']).subscribe(data => {
          this.authorInfo.avatar = window.URL.createObjectURL(new Blob([data], {type: data.type}));
        }, error => {
          console.log('getNewsAuthorAvatar error', error);
          this.authorInfo.avatar = this.authorAvatarHolder;
        });
      } else {
        this.authorInfo.avatar = this.authorAvatarHolder;
      }
    } else {
      this.authorInfo.avatar = this.authorAvatarHolder;
    }
    this.newsDate = data['createDate'];
    this.comments = data['comments'];
    this.creatorId = data['creatorId'];
    setTimeout(() => {
      this.gotoPageElement('header');
      this._utils.blockStop();
    }, 1000);
  }

  getNewByTagId(id) {
    if (id) {
      this.router.navigate(['/news/tag/' + id]);
    }
  }


  editNews() {
    if (this.newsId) {
      this.router.navigate(['moderator/add-edit-news/' + this.newsId]);
    }
  }


  onLangChange(language: Language): void {
    this.loadNewsContent();
  }

  sanitize(url: string) {
    if (this.newsImage === this.newsImageLink) {
      return url;
    } else if (url !== this.authorAvatarHolder) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return url;
  }

  goToCommentsForm() {
    this.gotoPageElement('comment-send-block');
  }

  gotoPageElement(el) {
    const element = document.getElementById(el);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/news-layout/news-layout.component.ts